import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    const finish = async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        localStorage.setItem("masetti_logged", "1");
        setUser(res.data);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: res.data } });
      } catch (e) {
        navigate("/admin", { replace: true });
      }
    };
    if (sessionId) finish(); else navigate("/admin", { replace: true });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-oak-dark">
      <p className="font-serif text-cream text-xl">Accesso in corso…</p>
    </div>
  );
}
